(() => {
  // Use the theme's normal cart POST so Shopify recalculates all discounts/taxes.
  // No parallel requests or cached totals: checkout submits the current quantities.
  function initCart(root=document) {
    root.querySelectorAll('[data-sr-cart]').forEach(cart => {
      if(cart.dataset.srReady) return;
      cart.dataset.srReady='true';
      const form=cart.querySelector('form'); if(!form) return;
      let timer;
      const save=()=>{clearTimeout(timer);if(form.reportValidity()) form.requestSubmit();};
      const schedule=()=>{clearTimeout(timer);timer=setTimeout(save,650);};
      form.addEventListener('click',e=>{
        const control=e.target.closest('[data-sr-change]');if(!control) return;
        e.preventDefault();const input=control.parentElement.querySelector('input');
        input.value=Math.max(0,(parseInt(input.value,10)||0)+(control.dataset.srChange==='increment'?1:-1));schedule();
      });
      form.addEventListener('change',e=>{if(e.target.matches('[name="updates[]"]'))schedule();});
      form.addEventListener('submit',()=>{clearTimeout(timer);});
    });
  }
  const header=document.querySelector('.header');
  function fitHeader(){
    if(!header || innerWidth<960){header?.style.removeProperty('--sr-header-fit');return;}
    header.style.removeProperty('--sr-header-fit');
    const nav=header.querySelector('.sr-family-nav'),left=header.querySelector('.header__links'),right=header.querySelector('.header__right'),trigger=header.querySelector('.sr-family-trigger');
    if(!nav||!left||!right||!trigger)return;
    let size=parseFloat(getComputedStyle(trigger).fontSize);
    for(let i=0;i<20 && (nav.scrollWidth>left.clientWidth || right.scrollWidth>right.clientWidth);i++){
      size-=.4;header.style.setProperty('--sr-header-fit',`${Math.max(8,size)}px`);
      if(size<=8)break;
    }
  }
  function initSlides(root=document){
    root.querySelectorAll('[data-sr-slideshow]').forEach(el=>{
      if(el.dataset.ready)return;el.dataset.ready='true';
      const slides=[...el.querySelectorAll('[data-slide]')],dots=[...el.querySelectorAll('[data-goto]')],pause=el.querySelector('[data-pause]');
      let current=0,timer,paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show=n=>{current=(n+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==current);dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===current)));};
      const stop=()=>clearInterval(timer);
      const start=()=>{stop();if(!paused&&!document.hidden&&slides.length>1)timer=setInterval(()=>show(current+1),6500);};
      const label=()=>{pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?({"es":"Reanudar presentación","fr":"Reprendre le diaporama","de":"Diashow fortsetzen","nl":"Diavoorstelling hervatten","pt":"Retomar apresentação"}[document.documentElement.lang.toLowerCase().split("-")[0]] || "Resume slideshow"):({"es":"Pausar presentación","fr":"Mettre le diaporama en pause","de":"Diashow pausieren","nl":"Diavoorstelling pauzeren","pt":"Pausar apresentação"}[document.documentElement.lang.toLowerCase().split("-")[0]] || "Pause slideshow"));};
      el.addEventListener('click',e=>{const dot=e.target.closest('[data-goto]');if(dot){show(Number(dot.dataset.goto));start();}if(e.target.closest('[data-pause]')){paused=!paused;label();start();}});
      el.addEventListener('mouseenter',stop);el.addEventListener('mouseleave',start);el.addEventListener('focusin',stop);el.addEventListener('focusout',e=>{if(!el.contains(e.relatedTarget))start();});
      document.addEventListener('visibilitychange',start);label();start();
    });
  }
  initCart();initSlides();fitHeader();addEventListener('resize',fitHeader);document.fonts?.ready.then(fitHeader);
  document.addEventListener('shopify:section:load',e=>{initCart(e.target);initSlides(e.target);fitHeader();});
})();
